import React, { useState, useEffect } from "react";
import "./page5Styles.css";
import { motion } from "framer-motion";
import page5Img1 from "../../Assets/1x/Asset 30.png";
import page5Img21 from "../../Assets/1x/Asset 31.1.png";
import page5Img22 from "../../Assets/1x/Asset 31.2.png";
import page5Img23 from "../../Assets/1x/Asset 31.3.png";
import page5Img24 from "../../Assets/1x/Asset 31.4.png";
import page5Img25 from "../../Assets/1x/Asset 31.5.png";
import page5Img26 from "../../Assets/1x/Asset 31.6.png";
import page5Img27 from "../../Assets/1x/Asset 31.7.png";
import page5Img28 from "../../Assets/1x/Asset 31.8.png";
import page5Img29 from "../../Assets/1x/Asset 31.9.png";
import page5Img210 from "../../Assets/1x/Asset 31.10.png";
import page5Img211 from "../../Assets/1x/Asset 31.11.png";
import page5Img212 from "../../Assets/1x/Asset 31.12.png";
import page5Img2 from "../../Assets/1x/Asset 31.png";
import MyQuizWidget from "./MyQuizWidget";
import page5Img5 from "../../Assets/1x/Asset 36.png"; // First alphabet image
import namesData from "../../names.json"; // JSON file with names mapping

// Slider images array
const sliderImages = [
  page5Img2,
  page5Img21,
  page5Img22,
  page5Img23,
  page5Img24,
  page5Img25,
  page5Img26,
  page5Img27,
  page5Img28,
  page5Img29,
  page5Img210,
  page5Img211,
  page5Img212,
];

export default function Page5() {
  // detect mobile breakpoint
  //const isMobile = window.innerWidth <= 768;
  const isMobile = true;

  // determine visible slides based on window width
  const ww = window.innerWidth - 17;
  let visibleSlides = ww > 768 ? 3 : ww <= 452 ? 1 : 2;

  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50; // px threshold

  // auto-advance every 5 seconds
  useEffect(() => {
    const iv = setInterval(() => {
      setCurrentSlide((s) =>
        s < sliderImages.length - visibleSlides ? s + 1 : 0
      );
    }, 5000);
    return () => clearInterval(iv);
  }, [visibleSlides]);

  // arrow controls
  const nextSlide = () =>
    setCurrentSlide((s) =>
      s < sliderImages.length - visibleSlides ? s + 1 : 0
    );
  const prevSlide = () =>
    setCurrentSlide((s) =>
      s > 0 ? s - 1 : sliderImages.length - visibleSlides
    );

  // touch handlers for swipe
  const handleTouchStart = (e) =>
    setTouchStart(e.touches[0].clientX);
  const handleTouchMove = (e) =>
    setTouchEnd(e.touches[0].clientX);
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance) {
      nextSlide();
    } else if (-distance > minSwipeDistance) {
      prevSlide();
    }
    setTouchStart(null);
    setTouchEnd(null);
  };

  // build alphabet images array
  const alphabethImages = [
    page5Img5,
    ...Array.from({ length: 32 }, (_, i) => {
      try {
        return require(`../../Assets/1x/Asset 36.${i + 1}.png`);
      } catch {
        return null;
      }
    }),
  ];
  const alphabetOrder = Object.keys(namesData);

  // show names popup
  const showNames = (letter) => {
    const names = namesData[letter] || [];
    const popup1 = document.getElementById("popup_");
    const popup2 = document.getElementById("popup2");
    popup2.innerHTML = names.map((n) => `<p>&bullet; ${n}</p>`).join("");
    popup1.style.display = "flex";
  };

  return (
    <div className="page5">
      <div className="page5-block">
        <div className="page5-block-main-content-block">
          {/* Title Image */}
          <motion.img
            src={page5Img1}
            className="page5-block-main-content-block-title-img"
            alt=""
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 2, ease: "easeOut" }}
            viewport={{ once: isMobile }}
          />

          {/* Slider Section */}
          <motion.div
            className="page5-block-main-content-block-slider-div"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 2, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: isMobile }}
          >
            <div
              className="slider-container"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div
                className="slides"
                style={{
                  transform: `translateX(-${
                    (currentSlide * 100) / visibleSlides
                  }%)`,
                }}
              >
                {sliderImages.map((src, idx) => (
                  <div key={idx} className="slide">
                    <img src={src} alt={`Slide ${idx + 1}`} />
                  </div>
                ))}
              </div>
              <button
                className="slider-button prev-button"
                onClick={prevSlide}
              />
              <button
                className="slider-button next-button"
                onClick={nextSlide}
              />
            </div>
          </motion.div>

          {/* Parcel Section */}
          <motion.div
            className="page5-block-main-content-block-parcel-first-block"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 2, ease: "easeOut", delay: 0.3 }}
            viewport={{ once: isMobile }}
          >
            <div className="gif-div">
              <div className="page5-block-main-content-block-parcel-first-block-title">
                <p>იქნებ შენს სახელზე წერილია</p>
              </div>
              <div className="page5-block-main-content-block-parcel-second-block">
                <div className="page5-block-main-content-block-parcel-second-block-text-div">
                  <p>
                    აირჩიე შენი გვარის პირველი ასო <br />
                    და მოძებნე შენი თავი სიაში
                  </p>
                </div>
              </div>
            </div>

            {/* Alphabet Grid */}
            <div className="Alphabeth">
              {alphabethImages.map((img, i) => {
                const key = alphabetOrder[i];
                const xOffset = i % 2 === 0 ? -100 : 100;
                return (
                  <motion.div
                    key={i}
                    className="alphabet-item"
                    onClick={() => showNames(key)}
                    initial={{ opacity: 0, x: xOffset }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{
                      duration: 1,
                      ease: "easeOut",
                      delay: i * 0.03,
                    }}
                    viewport={{ once: isMobile }}
                  >
                    <img
                      src={img}
                      alt={`Alphabet ${i + 1}`}
                      className="alphabet-img"
                      data-letter={key}
                    />
                  </motion.div>
                );
              })}
            </div>

            {/* MyQuiz Widget */}
            <motion.div
              className="myquiz"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 2, ease: "easeOut", delay: 0.4 }}
              viewport={{ once: isMobile }}
            >
              <MyQuizWidget />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
